interface Provider {
	request(args: { method: string; params?: unknown[] }): Promise<any>
}

export interface TxFees {
	maxPriorityFeePerGas?: string
	maxFeePerGas?: string
}

// MetaMask rejects null fee params, and omitting them makes web3 1.x fill a
// hardcoded 2.5 gwei tip (too low on Polygon). Ask the wallet's node instead.
// An empty result lets web3 fall back to its own pricing.
export async function txFees(provider: Provider | null | undefined): Promise<TxFees> {
	if (!provider) {
		return {}
	}

	try {
		const [tip, block] = await Promise.all([
			provider.request({ method: 'eth_maxPriorityFeePerGas' }),
			provider.request({ method: 'eth_getBlockByNumber', params: ['latest', false] }),
		])

		if (!tip || !block?.baseFeePerGas) {
			return {}
		}

		const maxFee = BigInt(block.baseFeePerGas) * 2n + BigInt(tip)

		return {
			maxPriorityFeePerGas: '0x' + BigInt(tip).toString(16),
			maxFeePerGas: '0x' + maxFee.toString(16),
		}
	} catch (e) {
		console.warn('failed to fetch fee suggestion; using web3 defaults', e)
		return {}
	}
}
